import { fetchTenants } from '../services/fulfiller.service';
import { Tenant } from '../models/Tenant';
import { isEmpty } from 'lodash';
import { FulfillerItem } from '@/models/HeaderTypes';

/**
 * Retrieves the fulfiller list from the configured URL for the current environment.
 * Groups tenants by fulfillerId and combines their fulfiller locations.
 */
export const retrieveFulfillerList = async (): Promise<FulfillerItem[]> => {
  // Check if the cache exists and is still valid
  const cacheKey = 'fulfillerListCache';
  const cache = sessionStorage.getItem(cacheKey);

  if (cache) {
    const cachedData = JSON.parse(cache);
    const cacheTimestamp = cachedData.timestamp;
    const currentTime = Date.now();

    // Check if the cache is still valid (30 seconds)
    if (currentTime - cacheTimestamp < 30000) {
      return cachedData.data;
    }
  }

  const tenants: Tenant[] = await fetchTenants();
  const fulfillerList: FulfillerItem[] = [];
  tenants.forEach((tenant) => {
    // Check if the required fields are present
    if (
      isEmpty(tenant.fulfillmentLocationName) ||
      isEmpty(tenant.fulfillmentTenantKey) ||
      isEmpty(tenant.fulfillerId) ||
      isEmpty(tenant.fulfillerName)
    ) {
      return;
    }

    const existingFulfiller = fulfillerList.find(
      //For now grouping is based on fulfillerName
      //in future this can be moved to fulfiller level when we have more clarity
      (f) => f.fulfiller.label === tenant.fulfillerName,
    );
    if (existingFulfiller) {
      existingFulfiller.fulfillerLocations.push({
        label: tenant.fulfillmentLocationName,
        value: tenant.fulfillmentTenantKey,
      });
    } else {
      fulfillerList.push({
        fulfiller: {
          label: tenant.fulfillerName,
          value: tenant.fulfillerId + '_' + tenant.fulfillmentTenantKey,
        },
        fulfillerLocations: [
          {
            label: tenant.fulfillmentLocationName,
            value: tenant.fulfillmentTenantKey,
          },
        ],
        xCometAccountId: tenant.fulfillmentCometAccountId,
      });
    }
  });

  // Cache the response in session storage
  sessionStorage.setItem(
    cacheKey,
    JSON.stringify({ data: fulfillerList, timestamp: Date.now() }),
  );

  return fulfillerList;
};
